import axios from 'axios'
import { clone, objectSnakeToCamelCase } from '@/util/libUtil.js'
import qs from 'qs'

const state = {
    accessToken: null,
    refreshToken: null,
    initialized: false,
    isLoadingLogin: false,
    rol: null,
    isAdmin: false,
    nombre: null,
    id: null,
    groups: [],
    // cuenta: null,
    INITIALISE_INFO: [
        'cuenta',
        'origenesBbdd',
        'opciones',
        'tenantInfo',
        'communicates'
    ],
    paths: {
        ApiTokenPath: '/api/token/',
        RefreshTokenPath: '/api/token-refresh/',
        UserDetailPath: '/api/cuentas/detalle/',
        getPermissionsPath: '/api/get-group-permissions',
        checkinvalidPunchInPath: '/api/cuentas/check-invalid-punch-in/',
    }
}

const mutations = {
    updateStorage(state, { access, refresh }) {
        state.accessToken = access
        state.refreshToken = refresh
    },
    updateUserDetails(state, { isAdmin, rol, nombre, id, groups }) {
        state.isAdmin = isAdmin
        state.rol = rol
        state.nombre = nombre
        state.id = id
        state.groups = groups
    },
    destroyToken(state) {
        state.initialized = false
        state.accessToken = null
        state.refreshToken = null
        localStorage.clear()
    },
    cuenta: (state, val) => {
        state.cuenta = clone(val)
    },
    isLoadingLogin: (state, val) => {
        state.isLoadingLogin = val
    }
}

const actions = {
    async checkGroupPermission({ commit, state, getters }, groups) {
        let resp = await axios.get(getters.getEndpointFromPath(state.paths.getPermissionsPath), { params: { 'permission_name': groups } })
        return resp.data
    },
    userLogOut(context) {
        if (context.getters.loggedIn) {
            context.commit('destroyToken')
        }
    },
    userLogin(context, usercredentials) {
        return new Promise((resolve, reject) => {
            axios.post(context.getters.ApiTokenEndpoint, {
                username: usercredentials.username,
                password: usercredentials.password
            })
                .then(async response => {
                    localStorage.setItem('accessToken', response.data.access)
                    localStorage.setItem('refreshToken', response.data.refresh)
                    context.commit('updateStorage', { access: response.data.access, refresh: response.data.refresh })
                    // context.dispatch('getUserDetails')
                    await context.dispatch('initialise')

                    // console.log('Logged ' + context.getters.loggedIn)
                    resolve()
                }).catch((error) => {
                    reject(error)
                })
        })
    },
    refreshToken(context) {
        return new Promise((resolve, reject) => {
            const uninterceptedAxiosInstance = axios.create()

            uninterceptedAxiosInstance.post(context.getters.RefreshTokenEndpoint, {
                refresh: context.state.refreshToken,
            })
                .then(response => {
                    context.commit('updateStorage', { access: response.data.access, refresh: context.state.refreshToken })
                    localStorage.setItem('accessToken', response.data.access)
                    // context.dispatch('getUserDetails')
                    resolve(response.data.access)
                }).catch((error) => {
                    // console.log('no entiendo')
                    reject(error)
                })
        })
    },
    getUserDetails(context) {
        return new Promise((resolve, reject) => {
            // let ONE_HOUR = 60 * 60 * 1000;
            // let lastUpdate = Date(localStorage.getItem('meta')['date'])
            // ((new Date) - lastUpdate) < ONE_HOUR

            axios.get(context.getters.getEndpointFromPath(context.state.paths.UserDetailPath))
                .then(response => {
                    let nombre = response.data.nombre_completo == "" ?
                        response.data.username
                        :
                        (response.data.nombre_completo)
                    context.commit('updateUserDetails', {
                        isAdmin: response.data.isAdmin,
                        rol: response.data.rol.id,
                        nombre: nombre,
                        id: response.data.id,
                        groups: response.data.tenant_groups
                    })
                    localStorage.setItem('cuenta', JSON.stringify(objectSnakeToCamelCase(response.data)))
                    if (!localStorage.getItem('meta') || !'date' in JSON.parse(localStorage.getItem('meta')))
                        context.dispatch('rrhh/fetchCommunicates', { created_on: new Date().toISOString().slice(0, 10), receivers: response.data.id, is_read: 0 }, { root: true })
                    resolve()
                }).catch((error) => {
                    reject(error)
                })
        })
    },
    getCheckinvalidPunchIn(context) {
        return new Promise((resolve, reject) => {
            axios.get(context.getters.getEndpointFromPath(context.state.paths.checkinvalidPunchInPath))
                .then(response => {
                    localStorage.setItem('invalidPunchIn', JSON.stringify(response.data))
                    resolve()
                }).catch((error) => {
                    reject(error)
                })
        })
    },
    async initialise({ state, dispatch, commit, getters }) {
        if (state.isLoadingLogin) {
            return
        }
        return new Promise((resolve, reject) => {
            // Check if the ID exists
            if (localStorage.getItem('accessToken')) {
                state.accessToken = localStorage.getItem('accessToken')
            } else {
                resolve('Success')
            }

            if (localStorage.getItem('refreshToken')) {
                state.refreshToken = localStorage.getItem('refreshToken')
            }

            // let promises = []

            state.initialized = true
            setTimeout(async () => {
                commit('isLoadingLogin', true)
                let meta = {
                    date: new Date(),
                    readCommunicates: false
                }

                if (state.accessToken) {
                    // try {
                        await Promise.all([
                            dispatch('getUserDetails'),
                            dispatch('util/fetchTenantInfo', null, { root: true }),
                            dispatch('util/fetchOpciones', null, { root: true }), 
                            dispatch('getCheckinvalidPunchIn'),
                        ])
                        if (getters.isDistributor) {
                            await Promise.all([
                                dispatch('util/fetchOrigenesBBDD', null, { root: true }),
                            ])
                        }
                        localStorage.setItem('meta', JSON.stringify(meta))
                        resolve('Login success')
                    // } catch {
                    //     console.log('Ha habido un problema con el login')
                    //     reject('Ha habido un problema con el login')
                    // } finally {
                    commit('isLoadingLogin', false)
                    // }
                }
            }, 1)
        })
    },
}

const getters = {
    isDistributor: () => {
        const tenantInfo = localStorage.getItem('tenantInfo');
        try {
            return JSON.parse(tenantInfo)?.type == 'distributor'
        } catch (e) {
            return false;
        }
    },
    getInitialisePaths: (state) => {
        return state.INITIALISE_INFO
    },
    isAvatel() {
        const tenantInfo = localStorage.getItem('tenantInfo');
        try {
            return JSON.parse(tenantInfo)?.name == 'avatel'
        } catch (e) {
            return false;
        }
    },
    ckeckGroupPermission: (state) => (groups) => {
        if (!groups.length) {
            return true
        }

        let userGroups = state.groups.map((group) => group.name)
        return groups.some((group) => userGroups.includes(group))
    },

    checkRolePermission: (state, getters) => (rol) => {
        if (!rol) {
            return true
        }

        let letRolesGetters = {
            1: getters.hasSuperAdminPermission,
            2: getters.hasAdminPermission,
            3: getters.hasManagerPermission,
            4: getters.hasComercialPermission,
        }

        // call getters from this module according to the role id
        return letRolesGetters[rol];
    },

    isSetLocalStorage() {
        let init = true

        state.INITIALISE_INFO.forEach((element) => {
            if (localStorage.getItem(element) == null)
                init = false
        })

        return init
    },
    hasPermission: (state, _unused, rootState) => accessAllowedRoles => {
        let hasPermission = false;
        if (accessAllowedRoles) {
            accessAllowedRoles.forEach(role => {
                if (rootState.general.rolesEncode[role] == state.rol) {
                    hasPermission = true;
                }
            })
        }

        return hasPermission;
    },
    loggedIn(state) {
        return state.accessToken != null
    },
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
    ApiTokenEndpoint: (state, _unused, rootState) => (
        rootState.general.host + state.paths.ApiTokenPath
    ),
    RefreshTokenEndpoint: (state, _unused, rootState) => (
        rootState.general.host + state.paths.RefreshTokenPath
    ),
    hasComercialPermission: (state, _unused, rootState) => {
        return state.rol && state.rol == rootState.general.rolesEncode.Comercial
    },
    hasManagerPermission: (state, _unused, rootState) => {
        if (state.isAdmin)
            return true
        return state.rol && state.rol <= rootState.general.rolesEncode.Manager
    },
    hasAdminPermission: (state, _unused, rootState) => {
        if (state.isAdmin)
            return true
        return state.rol && state.rol <= rootState.general.rolesEncode.Admin
    },
    hasSuperAdminPermission: (state, _unused, rootState) => {
        if (state.isAdmin)
            return true
        return state.rol && state.rol <= rootState.general.rolesEncode.SuperAdmin
    },
    hasOnlyManagerPermission: (state, _unused, rootState) => {
        return state.rol && state.rol == rootState.general.rolesEncode.Manager
    },
    isComercialColaborador: (state, _unused, rootState) => {
        let cuenta = JSON.parse(localStorage.getItem('cuenta'))
        return state.rol && state.rol == rootState.general.rolesEncode.Comercial && cuenta?.tipoComercial == "COLABORADOR"
    },
    isComercialRecomendador: (state, _unused, rootState) => {
        let cuenta = JSON.parse(localStorage.getItem('cuenta'))
        return state.rol && state.rol == rootState.general.rolesEncode.Comercial && cuenta?.tipoComercial == "RECOMENDADOR"
    },
    isComercialCobOrRec: (state, getters, rootState) => {
        return getters.isComercialColaborador || getters.isComercialRecomendador
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
